import * as React from 'react';
import IspResultsContainer from './isp_results_container';
import IspSerpSorting from './isp_search_sorting';
import IspViewOption from './isp_view_option';

import dynamic from 'next/dynamic';
const IspRefine = dynamic(() => import('./isp_refine'), {
    ssr: false,
});

/**
 *
 * IspCenterContainer component
 * @extends {React.Component}
 */
class IspCenterContainer extends React.Component {
    public render(): JSX.Element | null {
        return (
            <>
                <div id='isp_center_container' style={{margin: 'auto 50px auto auto', float: 'left', width: '80%'}} className='isp_center_container isp_center_container_position'>
                    <div className='isp_center_container_header' data-no-instant>
                        <IspRefine
                            id='isp_refine_nevigation'
                        />
                        <div className='isp_sorting_and_result_view_wrapper'>
                            <IspSerpSorting/>
                            <div className='isp_search_res_view_type'>
                                <IspViewOption
                                    title='View results in grid mode'
                                    id='isp_mode_grid'
                                    code={0}
                                    image='https://cdn1-gae-ssl-default.akamaized.net/images/isp_icon_grid.png'
                                    alt='Grid mode'
                                />
                                <IspViewOption
                                    title='View results in list mode'
                                    id='isp_mode_grid'
                                    code={1}
                                    image='https://cdn1-gae-ssl-default.akamaized.net/images/isp_icon_list.png'
                                    alt='List mode'
                                />
                            </div>
                        </div>
                        <div className='isp_results_summary_wrapper'>
                            <h1 id='isp_results_summary'/>
                        </div>
                    </div>
                    <div id='isp_results_did_you_mean'/>
                    <div id='isp_search_results_filter_tags' style={{padding: 0}}/>
                    <IspResultsContainer/>
                    <div id='isp_search_res_progress' style={{height: '60px', textAlign: 'center'}}>
                        <br/><br/><br/>
                    </div>
                    <div id='isp_pagination_anchor' style={{textAlign: 'center'}}/>
                </div>
            </>
        );
    }
}
export default IspCenterContainer;